//@ts-ignore
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { Box } from 'src/components/mui';
import { fileExists } from 'src/utils';

type Props = {
  url: string;
  type?: 'video' | 'image';
  play?: boolean;
  blurBackground?: boolean;
};

/* @ts-ignore */
const ReactPlayerComponent = !!ReactPlayer.default ? ReactPlayer.default : ReactPlayer; //hotfix: https://github.com/akiran/react-slick/issues/2206#issuecomment-1961173249

const VideoWrapper = ({ children, blurBackground }) => {
  return (
    <Box
      position="absolute"
      sx={{
        zIndex: 1,
        width: '100vw !important',
        height: '100vh !important',
        background: 'black',
        filter: blurBackground ? 'blur(5px)' : 'none',
        overflow: 'hidden',

        '& iframe': {
          position: 'absolute !important',
          top: '50% !important',
          left: '50% !important',
          width: '100vw !important',
          height: '100vh !important',
          transform: 'translate(-50%, -50%)',

          '@media (min-aspect-ratio: 16/9)': {
            /* height = 100 * (9 / 16) = 56.25 */
            height: '56.25vw !important',
          },

          '@media (max-aspect-ratio: 16/9)': {
            /* width = 100 / (9 / 16) = 177.777777 */
            width: '177.78vh !important',
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export function FullScreenBackground({ url, type = 'image', blurBackground }: Props) {
  const [isValidUrl, setIsValidUrl] = useState(false);

  useEffect(() => {
    (async () => {
      const hasFile = await fileExists(url);
      if (hasFile) {
        setIsValidUrl(true);
      }
    })();
  }, [url]);

  return (
    <>
      {type === 'image' ? (
        <Box
          position="absolute"
          sx={{
            zIndex: 1,
            overflow: 'hidden',
            width: '100%',
            height: '100%',
          }}
        >
          <Box
            sx={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${url})`,
              ...(!isValidUrl && {
                backdropFilter: 'blur(10px)',
              }),
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              width: '100%',
              height: '100%',
              filter: blurBackground ? 'blur(5px)' : 'none',
              transform: 'scale(1.03)',
            }}
          />
        </Box>
      ) : type === 'video' ? (
        /*@ts-ignore*/
        <ReactPlayerComponent
          playsinline
          url={url}
          controls={false}
          wrapper={VideoWrapper}
          muted
          playing
          loop
          blurBackground={blurBackground}
          config={{ youtube: { playerVars: { modestbranding: 1 } } }}
        />
      ) : (
        <></>
      )}
    </>
  );
}
